import type { FC } from "react";
import React, { useState } from "react";

import clsx from "clsx";

import { Btn } from "./style";

import type { BaseButtonProps } from "../index";
import { ButtonTypes } from "../index";

export interface RegularButtonProps extends BaseButtonProps {
	placeholder?: string;
	variant?: ButtonTypes;
	value?: string;
	btnSelectorClassName?: string;
	btnContentClassName?: string;
}

const RegularButton: FC<RegularButtonProps> = ({
	children,
	className = "",
	loading,
	disabled,
	startIcon,
	endIcon,
	type,
	placeholder,
	variant,
	size,
	value,
	readonly,
	btnSelectorClassName,
	btnContentClassName,
	...rest
}) => {
	const [text, setText] = useState(typeof children === "string" ? children : value || "");

	const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
		setText(event.target.value);
	};

	return (
		<Btn
			className={clsx(
				className,
				(variant === ButtonTypes.FILL || variant === ButtonTypes.GOLD_BORD_FILL) && "filled",
				variant === ButtonTypes.GOLD_BORD_FILL && "gold-border",
				`size_${size}`
			)}
			disabled={loading || disabled}
			{...rest}
		>
			<div className={clsx("btn-content", btnContentClassName)}>
				<div className={clsx("flex items-center gap-[3px]")}>
					<div className={clsx("btn-selector", btnSelectorClassName)}>
						{!!startIcon && <div className="shrink-0">{startIcon}</div>}
						{type === "input" ? (
							<input
								type="text"
								value={text}
								onChange={onChangeText}
								className="input"
								placeholder={placeholder}
								disabled={disabled}
								readOnly={readonly}
							/>
						) : (
							<>
								{typeof children === "string" ? (
									<p className={clsx("font-mic text-base text-yellow-350")}>{children}</p>
								) : (
									children
								)}
							</>
						)}
						{!!endIcon && <div className="shrink-0">{endIcon}</div>}
					</div>
				</div>
			</div>
		</Btn>
	);
};

export default RegularButton;
